export const BadgeType = {
    normal: 'normal',
    challenge: 'challenge',
};
export class Badge {
    constructor(badgeData, config) {
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "completeImageSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "incompleteImageSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "badgeConditions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isReceived", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = badgeData.id;
        this.name = badgeData.name;
        this.description = badgeData.description;
        this.type = BadgeType[badgeData.type];
        this.completeImageSrc = badgeData.completeImageSrc;
        this.incompleteImageSrc = badgeData.incompleteImageSrc;
        this.isReceived = badgeData.isReceived;
        this.config = config;
        if (badgeData.badgeConditions) {
            this.badgeConditions = badgeData.badgeConditions.map((badgeCondition) => {
                return new BadgeCondition(badgeCondition);
            });
        }
    }
    get completeImageURL() {
        return this.config.cdnBaseURL + this.completeImageSrc;
    }
    get incompleteImageURL() {
        return this.config.cdnBaseURL + this.incompleteImageSrc;
    }
    get isChallenge() {
        return this.type === BadgeType.challenge;
    }
    // バッジ獲得済みの場合は獲得済みバッジ画像を返却し、獲得していない場合は未獲得バッジ画像を返却
    get renderImageURL() {
        if (this.isReceived) {
            return this.config.cdnBaseURL + this.completeImageSrc;
        }
        return this.config.cdnBaseURL + this.incompleteImageSrc;
    }
}
export const BadgeConditionType = {
    MINUTE: 'minute',
    TIME: 'time',
    CHALLENGE: 'challenge',
};
export class BadgeCondition {
    constructor(data) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "conditionType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "condition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "challengeID", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // conditionTypeがchallengeの場合、conditionにはChallengeプレイリストのIDがセットされているので、わかりやすい命名のパラメータを用意している
        Object.defineProperty(this, "badgeID", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.conditionType = data.conditionType;
        this.condition = data.condition;
        this.challengeID = data.condition;
        this.badgeID = data.badgeID;
    }
    get isCertificate() {
        return this.conditionType === BadgeConditionType.CHALLENGE;
    }
    get isMinuteBadge() {
        return this.conditionType === BadgeConditionType.MINUTE;
    }
}
